import { Component, ContentChildren, OnDestroy, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { VerticalProgressStepComponent } from '../vertical-progress-step/vertical-progress-step.component';

@Component({
  selector: 'ssg-vertical-progress-map',
  templateUrl: './vertical-progress-map.component.html',
  styleUrls: ['./vertical-progress-map.component.less']
})
export class VerticalProgressMapComponent implements OnDestroy {
  private _stepsSubscription: Subscription;
  private _stepStateSubscriptions: Subscription[] = [];

  @ContentChildren(VerticalProgressStepComponent)
  set steps(steps: QueryList<VerticalProgressStepComponent>) {
    if (this._stepsSubscription) {
      this._stepsSubscription.unsubscribe();
      this._stepsSubscription = null;
    }

    if (steps) {
      this._stepsSubscription = steps.changes.subscribe(() => this._annotateSteps(steps));
      this._annotateSteps(steps);
    }
  }

  constructor() { }

  ngOnDestroy() {
    if (this._stepsSubscription) {
      this._stepsSubscription.unsubscribe();
    }

    this._stepStateSubscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private _annotateSteps(steps: QueryList<VerticalProgressStepComponent>) {
    this._stepStateSubscriptions.forEach(subscription => subscription.unsubscribe());
    this._stepStateSubscriptions = [];

    const that = this;
    steps.forEach(function(step, index, array) {
      // Place a line between steps only if both steps are either in progress or complete.
      step.extendToNextStep = index < array.length - 1
        && (array[index].complete || array[index].inProgress)
        && (array[index + 1].complete || array[index + 1].inProgress);

      step.isLast = index === array.length - 1;

      that._stepStateSubscriptions.push(step.stateChanged.subscribe(() => that._annotateSteps(steps)));
    });
  }
}
